import { FC } from "react";
import Containers from "../../../components/Containers";
import SortedTable from "../../../components/tables/SortedTable";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import CustomerFormModal from "../../../components/modals/CustomerFormModal";

const CustomerLists: FC = () => {
  const { TableContainer } = Containers();
  return (
    <>
      <Breadcrumb
        name="Customers"
        subName="Customer Lists"
        path="/dashboard/v1"
      />

      <TableContainer>
        <SortedTable />
        <CustomerFormModal />
      </TableContainer>
    </>
  );
};

export default CustomerLists;
